function getSearchURLParams(url)
{
    if(typeof url !== "string") {
        return {};
    }
   var urlSplit = url.split("?");
   if(urlSplit.length < 2) {
       return {};
   }
   return _.object(_.map(urlSplit[1].split("&"), function(params) {
       return params.split("=");
   }));
}
var jQuery = require("jQuery");
function getSuitelet(script, deploy) {
   return {"customscript_ns_sc_ext_sl_advancedsignup:customdeploy_ns_sc_ext_sl_advancedsignup":"/app/site/hosting/scriptlet.nl?script=1084&deploy=1&compid=3290628&ns-at=AAEJ7tMQ-BuPQM4BN-o5RLK-bCKKJjZSxUne6k2KnCclw8hU0tU","customscript_ns_sc_sl_blog_entity_loader:customdeploy_ns_sc_sl_blog_entity_loader":"/app/site/hosting/scriptlet.nl?script=1510&deploy=1&compid=3290628&ns-at=AAEJ7tMQlRSfN72EZfcgLEXSnow0A3CL8fUiKzzqC-twd5iiZUY","customscript_ns_sc_sl_blog_post_searcher:customdeploy_ns_sc_sl_blog_post_searcher":"/app/site/hosting/scriptlet.nl?script=1512&deploy=1&compid=3290628&ns-at=AAEJ7tMQc_sJfLLhJA14XD1pNcsHlF-v--khPG53-I7Ih5cVTpw","customscript_ns_sc_sl_blog_url_prov:customdeploy_ns_sc_sl_blog_url_prov_dep":"/app/site/hosting/scriptlet.nl?script=1511&deploy=1&compid=3290628&ns-at=AAEJ7tMQzaP3_z9sP1Z1rBCy1WblcOwYuX4ILQ9wLHUD7yIqD5Q","customscript_ns_sc_sl_contact_us_form:customdeploy_ns_sc_sl_contact_us_form":"/app/site/hosting/scriptlet.nl?script=1067&deploy=1&compid=3290628&ns-at=AAEJ7tMQzwSLOcfmyCy0R8irDdeyOPpWpY51Hk-yB_F2Zac9xRQ","customscript_ns_sc_sl_id_isb:customdeploy_ns_sc_sl_id_isb":"/app/site/hosting/scriptlet.nl?script=2778&deploy=1&compid=3290628&ns-at=AAEJ7tMQ76J3Xqi4bx_pmRulngYKiYkAeaGhEZoo6Va7AJGs_GA","customscript_ns_sc_sl_inventory_display:customdeploy_ns_sc_sl_inventory_display":"/app/site/hosting/scriptlet.nl?script=1072&deploy=1&compid=3290628&ns-at=AAEJ7tMQYc4kbvRJonNkCCI_jO3pWOW34FlvczuzsO1dV2S-ioI","customscript_ns_sc_sl_itembadges:customdeploy_ns_sc_sl_itembadges":"/app/site/hosting/scriptlet.nl?script=1074&deploy=1&compid=3290628&ns-at=AAEJ7tMQMVO1qrN8UCToT-1ABfP8QhgJco8YBTuLwfy-QbgEM1I"}[script + ":" + deploy];
}
var xhrFactory = jQuery.ajaxSettings.xhr;
jQuery.ajaxSettings.xhr = function() {
   var xhr = xhrFactory.apply(this, arguments);
   var open = xhr.open;
   xhr.open = function () {
        var url = arguments[1];
        var assocParams = getSearchURLParams(url);
        if(assocParams.hasOwnProperty("script") && assocParams.hasOwnProperty("deploy")) {
            var hashed = getSuitelet(assocParams["script"], assocParams["deploy"]);
            if(hashed) {
                var hashedParams = getSearchURLParams(hashed);
                var keys = Object.keys(assocParams);
                for (var i=0; i<keys.length; i++) {
                    var key = keys[i];
                    var value = assocParams[key];
                    if(!hashedParams.hasOwnProperty(key))
                    {
                        hashed += "&" + key + "=" + value;
                    }
                }
                arguments[1] = hashed;
            }
        }
        return open.apply(this, arguments);
    }
    return xhr;
}